import { render, staticRenderFns } from "./prodNood.vue?vue&type=template&id=98b35642&scoped=true"
import script from "./prodNood.vue?vue&type=script&lang=js"
export * from "./prodNood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b35642",
  null
  
)

export default component.exports